const ROUTES = {
  WELCOME: "/welcome",
  HOME: "/home",
  INVITE: "/invite",
  DASHBOARD: "/dashboard",
  PREMIUMPLAN: "/plan",
  MENUPAGES: "/support",
  REPORT:"/report",
};

export default ROUTES;
